var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-label-text',{attrs:{"label":"名前","placeholder":"名前で絞り込み","value":_vm.searchStr},on:{"update:value":function($event){_vm.searchStr=$event}}}),_c('employee-search-table',{attrs:{"list":_vm.list,"searchWord":_vm.searchStr},on:{"update:list":function($event){_vm.list=$event},"clickRow":_vm.setEmployeeNo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }